var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCounter1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_193_2032)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 50,
    r: 40,
    fill: "#FF7E84"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M72.7061 42.2935C72.316 41.9035 71.6817 41.9035 71.2917 42.2935L65.2911 48.294C65.004 48.5812 64.9225 49.0098 65.0768 49.3827C65.2311 49.7556 65.5955 49.9999 66.0026 49.9999H74.6691C75.222 49.9999 75.6678 49.5499 75.6678 49.0012C75.6678 48.4526 75.2177 48.0026 74.6691 48.0026H71.6688C71.6688 47.1154 71.3474 46.2753 70.7902 45.6281L72.7061 43.7079C73.0961 43.3136 73.0961 42.6835 72.7061 42.2935ZM69.663 47.9983H68.4114L69.3629 47.0468C69.5558 47.3211 69.663 47.6511 69.663 47.9983Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M76.9987 36.666H63.6689C62.9317 36.666 62.3359 37.2661 62.3359 37.999C62.3359 38.7319 62.936 39.332 63.6689 39.332H77.003C77.7402 39.332 78.3359 39.932 78.3359 40.6649V51.3288C78.3359 52.066 77.7359 52.6617 77.003 52.6617H66.3349C65.5977 52.6617 65.0019 53.2618 65.0019 53.9947C65.0019 54.7276 65.5977 55.3277 66.3349 55.3277H76.9987C79.206 55.3277 80.9976 53.5318 80.9976 51.3245V40.6649C81.0019 38.4576 79.206 36.666 76.9987 36.666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.663 41.9979C57.8715 41.9979 59.6619 40.2075 59.6619 37.9989C59.6619 35.7904 57.8715 34 55.663 34C53.4544 34 51.6641 35.7904 51.6641 37.9989C51.6641 40.2075 53.4544 41.9979 55.663 41.9979Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3322 43.3311H53.9976C51.2459 43.3311 49 45.5727 49 48.3329V53.8406C49 54.7321 49.4929 55.5293 50.2901 55.9279L51.4817 56.5237C51.5974 56.5794 51.666 56.6951 51.666 56.8237V63.6643C51.666 64.9501 52.7118 66.0002 54.0019 66.0002H57.3365C58.6223 66.0002 59.6681 64.9544 59.6724 63.6643V56.8237C59.6724 56.6994 59.741 56.5837 59.8567 56.5237L61.0482 55.9279C61.8454 55.5293 62.3383 54.7321 62.3383 53.8406V48.3329C62.334 45.5727 60.0881 43.3311 57.3322 43.3311Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_193_2032",
    x: 0,
    y: 0,
    width: 130,
    height: 130,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.341176 0 0 0 0 0.262745 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_193_2032"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_193_2032",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounter1);
export default __webpack_public_path__ + "static/media/counter-1.bdf2e806eab6610b637d5f58876d250f.svg";
export { ForwardRef as ReactComponent };